import axios from 'axios'
import { put, call, takeLatest } from 'redux-saga/effects'

import apiConfig from '@services/apiConfig'

import {
  SEND_NOTIFICATION,
  LIST_MESSAGES,
  setMessages,
  GET_MESSAGE,
  setMessage,
  addMessage
} from '@actions/notification'
import errorHandler from '../errorHandler'

const classPrefix = '/notifications'

function* sendNotification({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix + classPrefix}`,
      data: {
        ...data,
      },
    })
    yield put(addMessage(response.data))
    callback && callback('Mensagem enviada com sucesso', null)
  } catch (error) {
    callback && callback('Erro ao enviar mensagem', error)
    errorHandler(error)
  }
}

function* listMessages({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/list-messages`,
      params,
    })
    yield put(setMessages(response.data))
    callback && callback(response.data)
  } catch (error) {
    errorHandler(error)
  }
}

function* getMessage({ messageId, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix + classPrefix}/get-message-by-id/${messageId}`,
    })
    yield put(setMessage(response.data))
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* sendNotificationSaga() {
  yield takeLatest(SEND_NOTIFICATION, sendNotification)
}

export function* listMessagesSaga() {
  yield takeLatest(LIST_MESSAGES, listMessages)
}

export function* getMessageSaga() {
  yield takeLatest(GET_MESSAGE, getMessage)
}
